module.exports = __webpack_public_path__ + "static/Grafika6-7abcaeb68b691d323d55839572a488fb.png";